// Tiny CSV exporter — RFC 4180-ish quoting, UTF-8 BOM for Excel friendliness.

function escapeCell(v) {
    if (v === null || v === undefined) return "";
    const s = typeof v === "string" ? v : String(v);
    if (/[",\n\r]/.test(s)) {
        return `"${s.replaceAll('"', '""')}"`;
    }
    return s;
}

export function rowsToCsv(headers, rows) {
    const headerLine = headers.map((h) => escapeCell(h.label)).join(",");
    const bodyLines = rows.map((r) =>
        headers.map((h) => escapeCell(typeof h.get === "function" ? h.get(r) : r[h.key])).join(",")
    );
    return "\uFEFF" + [headerLine, ...bodyLines].join("\n");
}

export function downloadCsv(filename, csv) {
    const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
}

export function exportCsv(filename, headers, rows) {
    downloadCsv(filename, rowsToCsv(headers, rows));
}
